import { Component, ViewEncapsulation } from '@angular/core';
import { fuseAnimations } from '@fuse/animations';
import { ActivatedRoute } from '@angular/router';
import { ParseService } from '../../../shared/common/parse/parse.service';
import { ProfileService } from './profile.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { Location } from '@angular/common';
import { SessionHandler } from 'app/shared/common/parse/session-handler';
import axios from 'axios';
import { StorageConfiguration } from 'app/shared/common/storage-setting/storage-configuration';
import { QueryInterface } from 'app/shared/common/parse/query-interface';
import { NgxSpinnerService } from 'ngx-spinner';
import { ProfileCropComponent } from './tabs/profile-crop/profile-crop.component';
import { environment } from '../../../../environments/environment';
@Component({
    selector: 'profile',
    templateUrl: './profile.component.html',
    styleUrls: ['./profile.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations
})

export class ProfileComponent {

    imageURL: string = 'assets/images/avatars/profile.jpg';
    fileToUpload: File = null;
    proImage: any;
    religionLists: any;
    formErrors: any;
    about: any;
    userroles: any;
    userroles1: any;
    profileroles: any;
    profileDetails: any;
    instance: any;
    religionvalue: any;
    organisationLists: any;
    departmentLists: any;
    reportingtoLists: any;
    designationLists: any;
    starttimeLists: any;
    objectId = this.parseService.instance.User.current().id;
    hideDemo = true;
    hideProfile = true;
    hideBack = true;
    hideProfessional = true;
    hideExperience = true;
    hidePro = true;
    hideExp = true;
    firstname: String;
    lastname: String;
    profileImgId: any;
    profileValue: any;
    profileId: any;
    profId: any;
    empRole: any;
    profileCropDialogRef: MatDialogRef<ProfileCropComponent>;
    apiUrl: any;
    tenantId: any;

    constructor(
        private route: ActivatedRoute,
        private parseService: ParseService,
        private profileService: ProfileService,
        public dialog: MatDialog,
        private _location: Location,
        private toastr: ToastrService,
        private sessionHandler: SessionHandler,
        private storageConfiguration: StorageConfiguration,
        private queryInterface: QueryInterface,
        private spinner: NgxSpinnerService,
    ) {
        this.tenantId = this.storageConfiguration.sessionGetItem(this.storageConfiguration.tenantId);

    }

    async ngOnInit() {
        let queryInstance = this.parseService.instance.Object.extend('DataSettings');
        let query = new this.parseService.instance.Query(queryInstance);
        await query.find().then(settings => {
            this.apiUrl = settings[0].get('apiUrl');
        });

        this.empRole = this.storageConfiguration.sessionGetItem(this.storageConfiguration.role);
        this.firstname = this.parseService.instance.User.current().get('firstName');
        this.lastname = this.parseService.instance.User.current().get('lastName');
        let user = this.parseService.instance.User.current().id;
        this.getProfilePhotos();
        this.route.params.subscribe(params => {
            let objectId = params['id'];
            if (objectId) {
                let user = new this.parseService.instance.Object('_User');
                user.id = this.objectId;
                user.fetch().then(
                    res => {
                        this.firstname = res.get('firstName');
                        this.lastname = res.get('lastName');
                    }
                ).catch(err => {
                    this.sessionHandler.handleParseError(err);
                });
            }

            if (objectId !== undefined) {
                if (user !== this.objectId) {
                    this.hideDemo = false;
                }
            } else {
                this.hideProfile = false;
                this.hideBack = false;
            }

            if (this.empRole == 'Admin' || this.empRole == 'Leader') {
                this.objectId = objectId == undefined ? this.objectId : objectId;
            }

        });
        this.getProfilePhotos();
    }


    async getProfilePhotos() {
        await this.queryInterface.executeQuery(this.parseService, 'User', [
            { condition: 'equalTo', field: 'objectId', value: this.objectId },
            { condition: 'include', value: 'profile' }]).then(result => {
                if (result.length > 0) {
                    var results = result[0];
                    var prof = results.get('profile');
                    let jsonText = JSON.stringify(prof);
                    let userProfile = JSON.parse(jsonText);
                    this.profileImgId = userProfile.profileImageInfo.imageId;
                    this.proImage = userProfile.profileImageInfo.url;
                    this.profileService.photosProfile.next(this.proImage);
                    this.spinner.hide();
                }
            });
    }

    uploadProfilePhoto(event) {
        var formData = new FormData();
        formData.append("file", event);
        this.spinner.show();
        var session = this.storageConfiguration.sessionGetItem(this.storageConfiguration.sessiontoken);
        axios.post(this.apiUrl.mediaPathStorage + this.tenantId, formData, {
            headers: {
                'AuthenticationKey': environment.profileUploadAuthenticationKey,
                // "authorization": "Bearer " + session,
                'Content-Type': "application/x-www-form-urlencoded"
            }
        }).then(aresf => {
            this.profileInfoUpdate(aresf);
        }).catch(err => {
            this.spinner.hide();
        });
    }

    async profileInfoUpdate(data) {
        await this.queryInterface.executeQuery(this.parseService, 'User', [
            { condition: 'equalTo', field: 'objectId', value: this.objectId },
            { condition: 'include', value: 'profile' }]).then(result => {
                var results = result[0];
                let jsonText = JSON.stringify(results);
                let userProfile = JSON.parse(jsonText);
                this.profileValue = userProfile;
                this.profileId = this.profileValue.profile.objectId;
            });
        await this.profileUpdate(data);
    }

    async profileUpdate(data) {
        await this.queryInterface.executeQuery(this.parseService, "Profile", [{ condition: "equalTo", field: "objectId", value: this.profileId }]).then(async results => {
            var result = results[0];
            // var profImage = {
            //     'imageId': data.data._id,
            //     'url': data.data.url
            // };
            const profileImg = {
                'imageId': data.data.data.Key,
                'url': data.data.data.Location,
                // 'size': data.data.profileSize,
            };
            result.set('profileImageInfo', profileImg);
            let res = await result.save();
            this.getProfilePhotos();
            this.toastr.success('Profile uploaded successfully');
        });
    }

    deleteprofileimage() {
        if (this.profileImgId != undefined) {
            var session = this.storageConfiguration.sessionGetItem(this.storageConfiguration.sessiontoken);
            axios.delete(this.apiUrl.mediaPath + this.profileImgId, {
                headers: {
                    "authorization": "Bearer " + session,
                    'Content-Type': "application/json"
                }
            }).then(aresf => {

            }).catch(err => {
                this.spinner.hide();
            });
        }
    }

    backlocation() {
        this._location.back();
    }

    openProfilePicUpload() {
        this.profileCropDialogRef = this.dialog.open(ProfileCropComponent, {
            width: '700px',
        });
        this.profileCropDialogRef.afterClosed().subscribe(result => {
            if (result.status) {
                this.uploadProfilePhoto(result.file);
            }
        });
    }

    handleMissingImage(event) {
        this.proImage = this.imageURL;
    }

}
